import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconConstructionHelmet: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"construction-helmet, work, wip"} maskId="square-filled-radius-0-stroke-1-IconConstructionHelmet"><path d="M3 13.5C3 9.58134 5.50442 6.24762 9 5.01212V15H3V13.5Z" fill="currentColor"/><path d="M21 15V13.5C21 9.58134 18.4956 6.24762 15 5.01212V15H21Z" fill="currentColor"/><path d="M2 16H22V20H2V16Z" fill="currentColor"/><path d="M10 4H14V15H10V4Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconConstructionHelmet;
